import Vue from "vue";
import vueAxios from "vue-axios";
import axios from "axios";

const commonAxios = {
  init() {
    Vue.use(vueAxios, axios);
    Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL + "/api/v1";
  },

  setHeader() {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${localStorage.getItem("auth_token")}`;
  },

  get(route, body) {
    return Vue.axios.get(route, body);
  },

  post(route, body) {
    return Vue.axios.post(route, body);
  },

  put(route, body) {
    return Vue.axios.put(route, body);
  },

  delete(route, body) {
    return Vue.axios.delete(route, body);
  },
};

export default commonAxios;
